import type { ReactNode } from 'react';
import { RouterLink } from '@redux-first-router-link';

import type { PortfolioUpdate } from './useUpdates';

import { getSlug } from './utils';

type Props = PortfolioUpdate & { children: ReactNode };

export const Narrative = ({ url, company, title, children }: Props) => {
  const { canonicalURL } = company;
  const slug = url && getSlug(canonicalURL, url);
  return (
    <RouterLink role="listitem" aria-label={title} noUnderline to={slug || ''}>
      {children}
    </RouterLink>
  );
};
